export default __webpack_public_path__ + "static/media/olla.b5921593.png";